import React from 'react';
import ReactPaginate from 'react-paginate';
import prev from '../../../assets/icons/Vector 2.svg';
export const FinanceTable = ({
  data,
  columns,
  loading,
  currentPage,
  totalPages,
  onPageChange,
  onRowClick
}) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount || 0);
  };

  const formatValue = (value, format) => {
    if (format === 'currency') {
      return formatCurrency(value);
    }
    return value || '-';
  };

  const handlePageClick = (event) => {
    onPageChange(event.selected + 1);
  };

  if (loading) {
    return (
      <div className="finance-table-loading">
        <div className="spinner"></div>
        <p>Loading data...</p>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="finance-table-empty">
        <p>No data available</p>
      </div>
    );
  }

  return (
    <div className="finance-table-container">
      <div className="table-wrapper">
        <table className="finance-table student-table">
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th
                  key={index}
                  style={{
                    width: column.width,
                    textAlign: column.align || 'left'
                  }}
                >
                  {column.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                onClick={() => onRowClick && onRowClick(row)}
                className={onRowClick ? 'clickable-row' : ''}
              >
                {columns.map((column, colIndex) => (
                  <td
                    key={colIndex}
                    style={{
                      textAlign: column.align || 'left',
                      fontWeight: column.format === 'currency' ? '500' : 'normal'
                    }}
                  >
                    {formatValue(row[column.accessor], column.format)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination-container">
          <ReactPaginate
            previousLabel={<img src={prev} alt="Previous" />}
            nextLabel={
              <svg
                width="7"
                height="12"
                viewBox="0 0 7 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.5 1L5.5 6L0.5 11"
                  stroke="#7F56DA"
                  strokeLinecap="round"
                />
              </svg>
            }
            breakLabel={'...'}
            pageCount={totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
            forcePage={currentPage - 1}
          />
        </div>
      )}
    </div>
  );
};
